import { create } from "zustand";

type TSystem = {
  isKamcoDemo: boolean;
  setIsKamcoDemo: (isKamcoDemo: boolean) => void;
}

export const SystemStore = create<TSystem>((set) => ({
  isKamcoDemo: false,
  setIsKamcoDemo: (isKamcoDemo: boolean) => set({ isKamcoDemo }),
}));